export const GENRES = [
  {
    value: 'psychological-thriller',
    label: 'Psychological Thriller',
  },
  {
    value: 'murder-mystery',
    label: 'Murder Mystery',
  },
  {
    value: 'business-strategy',
    label: 'Business & Strategy',
  },
  {
    value: 'memoir-narrative',
    label: 'Memoir & Narrative',
  },
  {
    value: 'social-sciences',
    label: 'Social Sciences',
  },
  {
    value: 'historical-fiction',
    label: 'Historical Fiction',
  },
  {
    value: 'contemporary',
    label: 'Contemporary',
  },
  {
    value: 'fantasy-mythology',
    label: 'Fantasy & Mythology',
  },
];
